<iframe src="/assets/styleguide/index.html" style="width:100%;height:100vh;border:none;display:block;"></iframe>
